window.$ = window.jQuery = require("jquery");
require("bootstrap");
require("slick-carousel");
require("slick-carousel/slick/slick.css");

import '@splidejs/splide/dist/css/splide.min.css';

// Luego los componentes JS
require("@fancyapps/fancybox");
require("./sitio");
const Splide = require('@splidejs/splide').default;

// Instancia sliders después de la carga
$(document).ready(function () {
    let slide_destacados = new Splide("#slide-destacados", {
        type: "loop",
        perPage: 1,
        autoplay: false,
        arrows: true,
        pagination: false,
        interval: 10000,
    }).mount();

    let slide_proyecto = $("#slide-inicio").find('.contenido-inicio').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        autoplay: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),

    })

    setTimeout(() => {
        require("./components/FormularioAmigo");
        require("./modal_promocion");
    }, 2000);
});

